import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    fetchNetDirectoryFileNameListData,
    TNetDirectoryFileArgs,
    postDocumentUploadTemplateConfiguration,
} from './net-directory-file-slice-api';
import {
    NET_DIRECTORY_FILE_SLICE,
} from './net-directory-file-slice-constants';
import {INetDirectoryFileData} from './net-directory-file-slice-type';

export const loadNetDirectoryFileNameList = createAsyncThunk<string[]>(
    `${NET_DIRECTORY_FILE_SLICE}/loadNetDirectoryFileNameList`,
    async (_, {rejectWithValue}) => {
        try {
            const response = await fetchNetDirectoryFileNameListData();
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const loadNetDirectoryFile = createAsyncThunk<
    INetDirectoryFileData, TNetDirectoryFileArgs
>(
    `${NET_DIRECTORY_FILE_SLICE}/loadNetDirectoryFile`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await postDocumentUploadTemplateConfiguration(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
